import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { BankDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-bank-container',
  templateUrl: './bank-container.component.html',
  styleUrls: ['./bank-container.component.scss']
})
export class BankContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  banks$: Observable<BankDto[]>;
  loading: boolean;
  isLoadingBank$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingBank$ = this.gatwayFacade.isLoadingGateway("Bank");
    this.banks$ = this.gatwayFacade.loadGateway("Bank");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteBank(deletedValue: any) {
    this.gatwayFacade.remove("Bank", deletedValue);
  }


// this method control both the create and update

  onSubmitBank(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Banks;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllBank = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllBank.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllBank.length > 0) {
    this.gatwayFacade.add('Bank', addAllBank);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('Bank', allUpdates, ['id']);
  }

   }


}
